<template>
  <section class="elect-president" v-if="data">
    <ElectLabel :year="year" :category="category" :color="themeColor" />
    <SegmentChart
      :caption="segmentChartCaption"
      :winner-color="themeColor"
      :colors="segmentChartColors"
      :values="segmentChartValues"
      :labels="segmentChartLabels"
      :roles="segmentChartRoles"/>
    <SummaryTable
      :data="summaryTableData"
      :head-color="themeColor"/>
    <DonutChart
      v-if="data.notVoting.all"
      :theme-color="themeColor"
      :display="donutChartDisplay"
      :comparison="donutChartComparison"
      :values="donutChartValues"
      :colors="['#c6c6c6', themeColor]"
      :labels="['投票數', '未投票']"/>
    <NotVotingTable
      v-if="data.notVoting.counties && data.notVoting.counties.length"
      :color="themeColor"
      :data="notVotingTableData"/>
  </section>
</template>

<script>
import { PARTY_COLORS } from '@/constant'
import ElectLabel from '@/components/ElectLabel'
import SegmentChart from '@/components/SegmentChart'
import SummaryTable from '@/components/SummaryTable'
import DonutChart from '@/components/DonutChart'
import NotVotingTable from '@/components/NotVotingTable'

export default {
  name: 'ElectPresident',
  components: {
    ElectLabel,
    SegmentChart,
    SummaryTable,
    DonutChart,
    NotVotingTable
  },
  props: {
    data: { type: Object, default: () => {} }
  },
  data () {
    return {
      category: '總統',
      themeColor: '#ffca69'
    }
  },
  computed: {
    year () {
      return this.data.year.toString()
    },
    segmentChartCaption () {
      return '得票率'
    },
    segmentChartColors () {
      return this.data.result.map(({ party }) => PARTY_COLORS[party])
    },
    segmentChartValues () {
      return this.data.result.map(({ proportion }) => proportion)
    },
    segmentChartLabels () {
      return []
    },
    segmentChartRoles () {
      return this.data.result.map(({ name, vice }) => {
        if (!name) {
          return []
        }
        return [name, vice]
      })
    },
    summaryTableData () {
      return this.data.result.map(({ party, votes, proportion, offsetProportion, offsetVotes }) => {
        return { party, votes, proportion, offsetProportion, offsetVotes }
      })
    },
    donutChartDisplay () {
      return this.data.notVoting.all.notVotes
    },
    donutChartComparison () {
      return this.data.notVoting.all.offsetProportion
    },
    donutChartValues () {
      const { proportion, notProportion } = this.data.notVoting.all
      return [ proportion, notProportion ]
    },
    notVotingTableData () {
      return this.data.notVoting.counties.map(({ county, notVotes, notProportion }) => ({ county, notVotes, notProportion }))
    }
  }
}
</script>

<style lang="scss">
.elect-president {
  .segment-chart__role {
    @include rwd($RWD_TABLET) {
      margin-top: 10px;
    }
  }
  .segment-chart__role-item {
    font-size: 1.125em;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1.25em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.375em;
    }
  }
}
</style>
